import React from 'react'
import styles from './index.module.scss';

interface DividerProps {
    color?: string,
    style?: React.CSSProperties
}

export default function Divider({color = "#ECEBF7", style}: DividerProps){
    return(
        <div className={styles.divider} style={{...style, background: color}}/>
    )
}
